import { render, staticRenderFns } from "./GSchoolClassesTable.vue?vue&type=template&id=289ee542&"
import script from "./GSchoolClassesTable.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassesTable.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports